import {
    AnswerEntityId,
    IAnswer,
    LayoutSectionParentKey,
    QuestionSource,
    SectionRenderBehaviorType,
} from "@sp-crm/core";
import { ActivityEntityType } from "components/entity-activity/types";
import { NgGrid } from "components/shared/grid";
import { InteractionNotes } from "components/unified-timeline/interaction-notes";
import React from "react";
import { ResponsiveMode } from "store/reducers/responsive";
import { useResponsiveMode } from "store/selectors/hooks";
import { EntityLayoutContainer } from "./entity-layout-container";

interface EntityTabProps {
    columns: LayoutSectionParentKey[];
    entity: unknown;
    entityId: AnswerEntityId;
    entityType: ActivityEntityType;
    answerMode: QuestionSource;
    onAnswerCommitted: (answerEntityId: AnswerEntityId, answer: IAnswer) => void;
    onFieldChange: (field: string, value: string | boolean) => void;
}

export const EntityTab: React.FC<EntityTabProps> = props => {
    const {
        columns,
        entity,
        entityId,
        entityType,
        answerMode,
        onAnswerCommitted,
        onFieldChange,
    } = props;
    const responsiveMode = useResponsiveMode();
    const isMobile = responsiveMode < ResponsiveMode.large;
    return (
        <NgGrid>
            {isMobile ? (
                <NgGrid.Column>
                    <InteractionNotes entityId={entityId} entityType={entityType} />
                </NgGrid.Column>
            ) : null}
            {columns.map(column => (
                <NgGrid.Column key={column}>
                    <EntityLayoutContainer
                        containerKey={column}
                        entity={entity}
                        entityId={entityId}
                        entityType={entityType}
                        answerMode={answerMode}
                        onAnswerCommitted={onAnswerCommitted}
                        onFieldChange={onFieldChange}
                        excludeRenderBehaviors={
                            isMobile ? [SectionRenderBehaviorType.Notes] : []
                        }
                    />
                </NgGrid.Column>
            ))}
        </NgGrid>
    );
};
